<span class="holds-and-copies" data-automation-id="holds-and-copies-message">
  <span *ngIf="!shouldHideHolds" class="font-weight-bold">{{holds}}&nbsp;</span>
  <span *ngIf="!shouldHideHolds">{{ 'searchResultPageHolds' | translate:{holds: holds} }}</span>
  <span class="font-weight-bold ml-2">{{copies}}&nbsp;</span>
  <span>{{ 'searchResultPageCopies' | translate:{copies: copies} }}</span>
</span>
